export const blogs = [
    {
        id: "1st",
        image: "/etho/01.jpg",
        heading: "NUQI 2024 Ethosphere : 1st Edition",
        description: `It's worth the esports`,
        path: "https://nuqiwealth.com/pdf/NUQI-2024-Ethosphere-1st-Edition.pdf",
        content: (
            <>
                <p>
                    In recent years, the price of gold has experienced a
                    significant surge, reflecting its status as a valuable and
                    sought-after asset. Let’s delve into the factors behind this
                    remarkable rise and explore why gold continues to capture
                    the attention of investors worldwide.
                </p>

                <p>
                    1. Market Uncertainty: Gold has long been considered a
                    safe-haven asset, particularly during times of economic
                    uncertainty and geopolitical instability. In an increasingly
                    volatile global landscape, investors turn to gold as a store
                    of value and a hedge against inflation, currency
                    fluctuations, and market downturns. The uncertainty
                    surrounding major events such as Brexit, trade tensions, and
                    the COVID-19 pandemic has fueled demand for gold, driving
                    prices higher.
                </p>

                <p>
                    2.Low Interest Rates: In a low-interest-rate environment,
                    where traditional fixed-income investments offer minimal
                    returns, gold becomes more attractive as an alternative
                    asset class. With central banks around the world
                    implementing accommodative monetary policies and keeping
                    interest rates near historic lows, the opportunity cost of
                    holding gold diminishes, leading investors to allocate more
                    capital towards the precious metal.
                </p>

                <p>
                    3. Dollar Weakness: The inverse relationship between the US
                    dollar and gold prices is well-documented. A weaker US
                    dollar typically boosts demand for gold as it becomes
                    cheaper for international buyers. The depreciation of the
                    dollar against other major currencies, coupled with concerns
                    over its long-term stability, has bolstered gold prices and
                    contributed to its upward trajectory.
                </p>

                <p>
                    4.Supply Constraints: While the demand for gold continues to
                    rise, the supply side faces challenges such as declining
                    mine production and geopolitical tensions in key
                    gold-producing regions. These supply constraints put upward
                    pressure on gold prices, further driving its appreciation
                    over time.
                </p>

                <p>
                    5. Investor Sentiment: Beyond its fundamental value, gold
                    also benefits from investor sentiment and market psychology.
                    As fear and uncertainty grip financial markets, investors
                    flock to gold for its perceived safety and stability,
                    creating a self-reinforcing cycle of demand that propels
                    prices higher.
                </p>
                <p>
                    As Ethigold strives to democratize gold ownership and make
                    it accessible to all individuals, the recent surge in gold
                    prices underscores the importance of including gold in a
                    diversified investment portfolio. With its mission to
                    revolutionize gold investment in India, Ethigold empowers
                    investors to participate in the potential wealth
                    preservation and growth offered by gold, ensuring financial
                    empowerment and security for a brighter tomorrow.
                </p>
            </>
        ),
        date: "March 18, 2024",
        tags: ["gold", "gold price", "gold rise"],
    },
    {
        id: "2nd",
        image: "/etho/02.jpg",
        heading: "NUQI 2024 Ethosphere : 2nd Edition",
        description: `What is the secret of american growth?`,
        path: "https://nuqiwealth.com/pdf/NUQI-2024-Ethosphere-2nd-Edition.pdf",
        content: (
            <>
                <p>
                    In recent years, the price of gold has experienced a
                    significant surge, reflecting its status as a valuable and
                    sought-after asset. Let’s delve into the factors behind this
                    remarkable rise and explore why gold continues to capture
                    the attention of investors worldwide.
                </p>

                <p>
                    1. Market Uncertainty: Gold has long been considered a
                    safe-haven asset, particularly during times of economic
                    uncertainty and geopolitical instability. In an increasingly
                    volatile global landscape, investors turn to gold as a store
                    of value and a hedge against inflation, currency
                    fluctuations, and market downturns. The uncertainty
                    surrounding major events such as Brexit, trade tensions, and
                    the COVID-19 pandemic has fueled demand for gold, driving
                    prices higher.
                </p>

                <p>
                    2.Low Interest Rates: In a low-interest-rate environment,
                    where traditional fixed-income investments offer minimal
                    returns, gold becomes more attractive as an alternative
                    asset class. With central banks around the world
                    implementing accommodative monetary policies and keeping
                    interest rates near historic lows, the opportunity cost of
                    holding gold diminishes, leading investors to allocate more
                    capital towards the precious metal.
                </p>

                <p>
                    3. Dollar Weakness: The inverse relationship between the US
                    dollar and gold prices is well-documented. A weaker US
                    dollar typically boosts demand for gold as it becomes
                    cheaper for international buyers. The depreciation of the
                    dollar against other major currencies, coupled with concerns
                    over its long-term stability, has bolstered gold prices and
                    contributed to its upward trajectory.
                </p>

                <p>
                    4.Supply Constraints: While the demand for gold continues to
                    rise, the supply side faces challenges such as declining
                    mine production and geopolitical tensions in key
                    gold-producing regions. These supply constraints put upward
                    pressure on gold prices, further driving its appreciation
                    over time.
                </p>

                <p>
                    5. Investor Sentiment: Beyond its fundamental value, gold
                    also benefits from investor sentiment and market psychology.
                    As fear and uncertainty grip financial markets, investors
                    flock to gold for its perceived safety and stability,
                    creating a self-reinforcing cycle of demand that propels
                    prices higher.
                </p>
                <p>
                    As Ethigold strives to democratize gold ownership and make
                    it accessible to all individuals, the recent surge in gold
                    prices underscores the importance of including gold in a
                    diversified investment portfolio. With its mission to
                    revolutionize gold investment in India, Ethigold empowers
                    investors to participate in the potential wealth
                    preservation and growth offered by gold, ensuring financial
                    empowerment and security for a brighter tomorrow.
                </p>
            </>
        ),
        date: "March 25, 2024",
        tags: ["gold", "gold price", "gold rise"],
    },
    {
        id: "3rd",
        image: "/etho/03.jpg",
        heading: "NUQI 2024 Ethosphere : 3rd Edition",
        description: `In the banking sector, big is powerful`,
        path: "https://nuqiwealth.com/pdf/NUQI-2024-Ethosphere-3rd-Edition.pdf",
        content: (
            <>
                <p>
                    In recent years, the price of gold has experienced a
                    significant surge, reflecting its status as a valuable and
                    sought-after asset. Let’s delve into the factors behind this
                    remarkable rise and explore why gold continues to capture
                    the attention of investors worldwide.
                </p>

                <p>
                    1. Market Uncertainty: Gold has long been considered a
                    safe-haven asset, particularly during times of economic
                    uncertainty and geopolitical instability. In an increasingly
                    volatile global landscape, investors turn to gold as a store
                    of value and a hedge against inflation, currency
                    fluctuations, and market downturns. The uncertainty
                    surrounding major events such as Brexit, trade tensions, and
                    the COVID-19 pandemic has fueled demand for gold, driving
                    prices higher.
                </p>

                <p>
                    2.Low Interest Rates: In a low-interest-rate environment,
                    where traditional fixed-income investments offer minimal
                    returns, gold becomes more attractive as an alternative
                    asset class. With central banks around the world
                    implementing accommodative monetary policies and keeping
                    interest rates near historic lows, the opportunity cost of
                    holding gold diminishes, leading investors to allocate more
                    capital towards the precious metal.
                </p>

                <p>
                    3. Dollar Weakness: The inverse relationship between the US
                    dollar and gold prices is well-documented. A weaker US
                    dollar typically boosts demand for gold as it becomes
                    cheaper for international buyers. The depreciation of the
                    dollar against other major currencies, coupled with concerns
                    over its long-term stability, has bolstered gold prices and
                    contributed to its upward trajectory.
                </p>

                <p>
                    4.Supply Constraints: While the demand for gold continues to
                    rise, the supply side faces challenges such as declining
                    mine production and geopolitical tensions in key
                    gold-producing regions. These supply constraints put upward
                    pressure on gold prices, further driving its appreciation
                    over time.
                </p>

                <p>
                    5. Investor Sentiment: Beyond its fundamental value, gold
                    also benefits from investor sentiment and market psychology.
                    As fear and uncertainty grip financial markets, investors
                    flock to gold for its perceived safety and stability,
                    creating a self-reinforcing cycle of demand that propels
                    prices higher.
                </p>
                <p>
                    As Ethigold strives to democratize gold ownership and make
                    it accessible to all individuals, the recent surge in gold
                    prices underscores the importance of including gold in a
                    diversified investment portfolio. With its mission to
                    revolutionize gold investment in India, Ethigold empowers
                    investors to participate in the potential wealth
                    preservation and growth offered by gold, ensuring financial
                    empowerment and security for a brighter tomorrow.
                </p>
            </>
        ),
        date: "April 8, 2024",
        tags: ["gold", "gold price", "gold rise"],
    },
    {
        id: "4th",
        image: "/etho/04.jpg",
        heading: "NUQI 2024 Ethosphere : 4th Edition",
        description: `Gold or The Dollar: Which will be stronger?`,
        path: "https://nuqiwealth.com/pdf/NUQI-2024-Ethosphere-4th-Edition.pdf",
        content: (
            <>
                <p>
                    In recent years, the price of gold has experienced a
                    significant surge, reflecting its status as a valuable and
                    sought-after asset. Let’s delve into the factors behind this
                    remarkable rise and explore why gold continues to capture
                    the attention of investors worldwide.
                </p>

                <p>
                    1. Market Uncertainty: Gold has long been considered a
                    safe-haven asset, particularly during times of economic
                    uncertainty and geopolitical instability. In an increasingly
                    volatile global landscape, investors turn to gold as a store
                    of value and a hedge against inflation, currency
                    fluctuations, and market downturns. The uncertainty
                    surrounding major events such as Brexit, trade tensions, and
                    the COVID-19 pandemic has fueled demand for gold, driving
                    prices higher.
                </p>

                <p>
                    2.Low Interest Rates: In a low-interest-rate environment,
                    where traditional fixed-income investments offer minimal
                    returns, gold becomes more attractive as an alternative
                    asset class. With central banks around the world
                    implementing accommodative monetary policies and keeping
                    interest rates near historic lows, the opportunity cost of
                    holding gold diminishes, leading investors to allocate more
                    capital towards the precious metal.
                </p>

                <p>
                    3. Dollar Weakness: The inverse relationship between the US
                    dollar and gold prices is well-documented. A weaker US
                    dollar typically boosts demand for gold as it becomes
                    cheaper for international buyers. The depreciation of the
                    dollar against other major currencies, coupled with concerns
                    over its long-term stability, has bolstered gold prices and
                    contributed to its upward trajectory.
                </p>

                <p>
                    4.Supply Constraints: While the demand for gold continues to
                    rise, the supply side faces challenges such as declining
                    mine production and geopolitical tensions in key
                    gold-producing regions. These supply constraints put upward
                    pressure on gold prices, further driving its appreciation
                    over time.
                </p>

                <p>
                    5. Investor Sentiment: Beyond its fundamental value, gold
                    also benefits from investor sentiment and market psychology.
                    As fear and uncertainty grip financial markets, investors
                    flock to gold for its perceived safety and stability,
                    creating a self-reinforcing cycle of demand that propels
                    prices higher.
                </p>
                <p>
                    As Ethigold strives to democratize gold ownership and make
                    it accessible to all individuals, the recent surge in gold
                    prices underscores the importance of including gold in a
                    diversified investment portfolio. With its mission to
                    revolutionize gold investment in India, Ethigold empowers
                    investors to participate in the potential wealth
                    preservation and growth offered by gold, ensuring financial
                    empowerment and security for a brighter tomorrow.
                </p>
            </>
        ),
        date: "April 15, 2024",
        tags: ["gold", "gold price", "gold rise"],
    },
    {
        id: "5th",
        image: "/etho/03.jpg",
        heading: "NUQI 2024 Ethosphere : 5th Edition",
        description: `In the banking sector, Big is powerful`,
        path: "https://nuqiwealth.com/pdf/NUQI-2024-Ethosphere-5th-Edition.pdf",
        content: (
            <>
                <p>
                    In recent years, the price of gold has experienced a
                    significant surge, reflecting its status as a valuable and
                    sought-after asset. Let’s delve into the factors behind this
                    remarkable rise and explore why gold continues to capture
                    the attention of investors worldwide.
                </p>

                <p>
                    1. Market Uncertainty: Gold has long been considered a
                    safe-haven asset, particularly during times of economic
                    uncertainty and geopolitical instability. In an increasingly
                    volatile global landscape, investors turn to gold as a store
                    of value and a hedge against inflation, currency
                    fluctuations, and market downturns. The uncertainty
                    surrounding major events such as Brexit, trade tensions, and
                    the COVID-19 pandemic has fueled demand for gold, driving
                    prices higher.
                </p>

                <p>
                    2.Low Interest Rates: In a low-interest-rate environment,
                    where traditional fixed-income investments offer minimal
                    returns, gold becomes more attractive as an alternative
                    asset class. With central banks around the world
                    implementing accommodative monetary policies and keeping
                    interest rates near historic lows, the opportunity cost of
                    holding gold diminishes, leading investors to allocate more
                    capital towards the precious metal.
                </p>

                <p>
                    3. Dollar Weakness: The inverse relationship between the US
                    dollar and gold prices is well-documented. A weaker US
                    dollar typically boosts demand for gold as it becomes
                    cheaper for international buyers. The depreciation of the
                    dollar against other major currencies, coupled with concerns
                    over its long-term stability, has bolstered gold prices and
                    contributed to its upward trajectory.
                </p>

                <p>
                    4.Supply Constraints: While the demand for gold continues to
                    rise, the supply side faces challenges such as declining
                    mine production and geopolitical tensions in key
                    gold-producing regions. These supply constraints put upward
                    pressure on gold prices, further driving its appreciation
                    over time.
                </p>

                <p>
                    5. Investor Sentiment: Beyond its fundamental value, gold
                    also benefits from investor sentiment and market psychology.
                    As fear and uncertainty grip financial markets, investors
                    flock to gold for its perceived safety and stability,
                    creating a self-reinforcing cycle of demand that propels
                    prices higher.
                </p>
                <p>
                    As Ethigold strives to democratize gold ownership and make
                    it accessible to all individuals, the recent surge in gold
                    prices underscores the importance of including gold in a
                    diversified investment portfolio. With its mission to
                    revolutionize gold investment in India, Ethigold empowers
                    investors to participate in the potential wealth
                    preservation and growth offered by gold, ensuring financial
                    empowerment and security for a brighter tomorrow.
                </p>
            </>
        ),
        date: "May 8, 2024",
        tags: ["gold", "gold price", "gold rise"],
    },
    {
        id: "6th",
        image: "/etho/06.png",
        heading: "NUQI 2024 Ethosphere : 6th Edition",
        description: `The thaw emerging markets, at last? `,
        path: "https://nuqiwealth.com/pdf/NUQI-2024-Ethosphere-6th-Edition.pdf",
        content: (
            <>
                <p>
                    In recent years, the price of gold has experienced a
                    significant surge, reflecting its status as a valuable and
                    sought-after asset. Let’s delve into the factors behind this
                    remarkable rise and explore why gold continues to capture
                    the attention of investors worldwide.
                </p>

                <p>
                    1. Market Uncertainty: Gold has long been considered a
                    safe-haven asset, particularly during times of economic
                    uncertainty and geopolitical instability. In an increasingly
                    volatile global landscape, investors turn to gold as a store
                    of value and a hedge against inflation, currency
                    fluctuations, and market downturns. The uncertainty
                    surrounding major events such as Brexit, trade tensions, and
                    the COVID-19 pandemic has fueled demand for gold, driving
                    prices higher.
                </p>

                <p>
                    2.Low Interest Rates: In a low-interest-rate environment,
                    where traditional fixed-income investments offer minimal
                    returns, gold becomes more attractive as an alternative
                    asset class. With central banks around the world
                    implementing accommodative monetary policies and keeping
                    interest rates near historic lows, the opportunity cost of
                    holding gold diminishes, leading investors to allocate more
                    capital towards the precious metal.
                </p>

                <p>
                    3. Dollar Weakness: The inverse relationship between the US
                    dollar and gold prices is well-documented. A weaker US
                    dollar typically boosts demand for gold as it becomes
                    cheaper for international buyers. The depreciation of the
                    dollar against other major currencies, coupled with concerns
                    over its long-term stability, has bolstered gold prices and
                    contributed to its upward trajectory.
                </p>

                <p>
                    4.Supply Constraints: While the demand for gold continues to
                    rise, the supply side faces challenges such as declining
                    mine production and geopolitical tensions in key
                    gold-producing regions. These supply constraints put upward
                    pressure on gold prices, further driving its appreciation
                    over time.
                </p>

                <p>
                    5. Investor Sentiment: Beyond its fundamental value, gold
                    also benefits from investor sentiment and market psychology.
                    As fear and uncertainty grip financial markets, investors
                    flock to gold for its perceived safety and stability,
                    creating a self-reinforcing cycle of demand that propels
                    prices higher.
                </p>
                <p>
                    As Ethigold strives to democratize gold ownership and make
                    it accessible to all individuals, the recent surge in gold
                    prices underscores the importance of including gold in a
                    diversified investment portfolio. With its mission to
                    revolutionize gold investment in India, Ethigold empowers
                    investors to participate in the potential wealth
                    preservation and growth offered by gold, ensuring financial
                    empowerment and security for a brighter tomorrow.
                </p>
            </>
        ),
        date: "May 13, 2024",
        tags: ["gold", "gold price", "gold rise"],
    },
    {
        id: "7th",
        image: "/etho/07.WEBP",
        heading: "NUQI 2024 Ethosphere : 7th Edition",
        description: `Which investors will have a sailor's mindset?`,
        path: "https://nuqiwealth.com/pdf/NUQI-2024-Ethosphere-7th-Edition.pdf",
        content: (
            <>
                <p>
                    In recent years, the price of gold has experienced a
                    significant surge, reflecting its status as a valuable and
                    sought-after asset. Let’s delve into the factors behind this
                    remarkable rise and explore why gold continues to capture
                    the attention of investors worldwide.
                </p>

                <p>
                    1. Market Uncertainty: Gold has long been considered a
                    safe-haven asset, particularly during times of economic
                    uncertainty and geopolitical instability. In an increasingly
                    volatile global landscape, investors turn to gold as a store
                    of value and a hedge against inflation, currency
                    fluctuations, and market downturns. The uncertainty
                    surrounding major events such as Brexit, trade tensions, and
                    the COVID-19 pandemic has fueled demand for gold, driving
                    prices higher.
                </p>

                <p>
                    2.Low Interest Rates: In a low-interest-rate environment,
                    where traditional fixed-income investments offer minimal
                    returns, gold becomes more attractive as an alternative
                    asset class. With central banks around the world
                    implementing accommodative monetary policies and keeping
                    interest rates near historic lows, the opportunity cost of
                    holding gold diminishes, leading investors to allocate more
                    capital towards the precious metal.
                </p>

                <p>
                    3. Dollar Weakness: The inverse relationship between the US
                    dollar and gold prices is well-documented. A weaker US
                    dollar typically boosts demand for gold as it becomes
                    cheaper for international buyers. The depreciation of the
                    dollar against other major currencies, coupled with concerns
                    over its long-term stability, has bolstered gold prices and
                    contributed to its upward trajectory.
                </p>

                <p>
                    4.Supply Constraints: While the demand for gold continues to
                    rise, the supply side faces challenges such as declining
                    mine production and geopolitical tensions in key
                    gold-producing regions. These supply constraints put upward
                    pressure on gold prices, further driving its appreciation
                    over time.
                </p>

                <p>
                    5. Investor Sentiment: Beyond its fundamental value, gold
                    also benefits from investor sentiment and market psychology.
                    As fear and uncertainty grip financial markets, investors
                    flock to gold for its perceived safety and stability,
                    creating a self-reinforcing cycle of demand that propels
                    prices higher.
                </p>
                <p>
                    As Ethigold strives to democratize gold ownership and make
                    it accessible to all individuals, the recent surge in gold
                    prices underscores the importance of including gold in a
                    diversified investment portfolio. With its mission to
                    revolutionize gold investment in India, Ethigold empowers
                    investors to participate in the potential wealth
                    preservation and growth offered by gold, ensuring financial
                    empowerment and security for a brighter tomorrow.
                </p>
            </>
        ),
        date: "May 20, 2024",
        tags: ["gold", "gold price", "gold rise"],
    },
    {
        id: "8th",
        image: "/etho/08.jpg",
        heading: "NUQI 2024 Ethosphere : 8th Edition",
        description: `In the kingdom, It's better to be united when investing`,
        path: "https://nuqiwealth.com/pdf/NUQI-2024-Ethosphere-8th-Edition.pdf",
        content: (
            <>
                <p>
                    In recent years, the price of gold has experienced a
                    significant surge, reflecting its status as a valuable and
                    sought-after asset. Let’s delve into the factors behind this
                    remarkable rise and explore why gold continues to capture
                    the attention of investors worldwide.
                </p>

                <p>
                    1. Market Uncertainty: Gold has long been considered a
                    safe-haven asset, particularly during times of economic
                    uncertainty and geopolitical instability. In an increasingly
                    volatile global landscape, investors turn to gold as a store
                    of value and a hedge against inflation, currency
                    fluctuations, and market downturns. The uncertainty
                    surrounding major events such as Brexit, trade tensions, and
                    the COVID-19 pandemic has fueled demand for gold, driving
                    prices higher.
                </p>

                <p>
                    2.Low Interest Rates: In a low-interest-rate environment,
                    where traditional fixed-income investments offer minimal
                    returns, gold becomes more attractive as an alternative
                    asset class. With central banks around the world
                    implementing accommodative monetary policies and keeping
                    interest rates near historic lows, the opportunity cost of
                    holding gold diminishes, leading investors to allocate more
                    capital towards the precious metal.
                </p>

                <p>
                    3. Dollar Weakness: The inverse relationship between the US
                    dollar and gold prices is well-documented. A weaker US
                    dollar typically boosts demand for gold as it becomes
                    cheaper for international buyers. The depreciation of the
                    dollar against other major currencies, coupled with concerns
                    over its long-term stability, has bolstered gold prices and
                    contributed to its upward trajectory.
                </p>

                <p>
                    4.Supply Constraints: While the demand for gold continues to
                    rise, the supply side faces challenges such as declining
                    mine production and geopolitical tensions in key
                    gold-producing regions. These supply constraints put upward
                    pressure on gold prices, further driving its appreciation
                    over time.
                </p>

                <p>
                    5. Investor Sentiment: Beyond its fundamental value, gold
                    also benefits from investor sentiment and market psychology.
                    As fear and uncertainty grip financial markets, investors
                    flock to gold for its perceived safety and stability,
                    creating a self-reinforcing cycle of demand that propels
                    prices higher.
                </p>
                <p>
                    As Ethigold strives to democratize gold ownership and make
                    it accessible to all individuals, the recent surge in gold
                    prices underscores the importance of including gold in a
                    diversified investment portfolio. With its mission to
                    revolutionize gold investment in India, Ethigold empowers
                    investors to participate in the potential wealth
                    preservation and growth offered by gold, ensuring financial
                    empowerment and security for a brighter tomorrow.
                </p>
            </>
        ),
        date: "June 3, 2024",
        tags: ["gold", "gold price", "gold rise"],
    },
    {
        id: "9th",
        image: "/etho/09.jpg",
        heading: "NUQI 2024 Ethosphere : 9th Edition",
        description: `Optimism has led to Euphoria`,
        path: "https://nuqiwealth.com/pdf/NUQI-2024-Ethosphere-9th-Edition.pdf",
        content: (
            <>
                <p>
                    In recent years, the price of gold has experienced a
                    significant surge, reflecting its status as a valuable and
                    sought-after asset. Let’s delve into the factors behind this
                    remarkable rise and explore why gold continues to capture
                    the attention of investors worldwide.
                </p>

                <p>
                    1. Market Uncertainty: Gold has long been considered a
                    safe-haven asset, particularly during times of economic
                    uncertainty and geopolitical instability. In an increasingly
                    volatile global landscape, investors turn to gold as a store
                    of value and a hedge against inflation, currency
                    fluctuations, and market downturns. The uncertainty
                    surrounding major events such as Brexit, trade tensions, and
                    the COVID-19 pandemic has fueled demand for gold, driving
                    prices higher.
                </p>

                <p>
                    2.Low Interest Rates: In a low-interest-rate environment,
                    where traditional fixed-income investments offer minimal
                    returns, gold becomes more attractive as an alternative
                    asset class. With central banks around the world
                    implementing accommodative monetary policies and keeping
                    interest rates near historic lows, the opportunity cost of
                    holding gold diminishes, leading investors to allocate more
                    capital towards the precious metal.
                </p>

                <p>
                    3. Dollar Weakness: The inverse relationship between the US
                    dollar and gold prices is well-documented. A weaker US
                    dollar typically boosts demand for gold as it becomes
                    cheaper for international buyers. The depreciation of the
                    dollar against other major currencies, coupled with concerns
                    over its long-term stability, has bolstered gold prices and
                    contributed to its upward trajectory.
                </p>

                <p>
                    4.Supply Constraints: While the demand for gold continues to
                    rise, the supply side faces challenges such as declining
                    mine production and geopolitical tensions in key
                    gold-producing regions. These supply constraints put upward
                    pressure on gold prices, further driving its appreciation
                    over time.
                </p>

                <p>
                    5. Investor Sentiment: Beyond its fundamental value, gold
                    also benefits from investor sentiment and market psychology.
                    As fear and uncertainty grip financial markets, investors
                    flock to gold for its perceived safety and stability,
                    creating a self-reinforcing cycle of demand that propels
                    prices higher.
                </p>
                <p>
                    As Ethigold strives to democratize gold ownership and make
                    it accessible to all individuals, the recent surge in gold
                    prices underscores the importance of including gold in a
                    diversified investment portfolio. With its mission to
                    revolutionize gold investment in India, Ethigold empowers
                    investors to participate in the potential wealth
                    preservation and growth offered by gold, ensuring financial
                    empowerment and security for a brighter tomorrow.
                </p>
            </>
        ),
        date: "June 17, 2024",
        tags: ["gold", "gold price", "gold rise"],
    },
    {
        id: "10th",
        image: "/etho/10.jpg",
        heading: "NUQI 2024 Ethosphere : 10th Edition",
        description: `France dissolves it's Parliment and Assets`,
        path: "https://nuqiwealth.com/pdf/NUQI-2024-Ethosphere-10th-Edition.pdf",
        content: (
            <>
                <p>
                    In recent years, the price of gold has experienced a
                    significant surge, reflecting its status as a valuable and
                    sought-after asset. Let’s delve into the factors behind this
                    remarkable rise and explore why gold continues to capture
                    the attention of investors worldwide.
                </p>

                <p>
                    1. Market Uncertainty: Gold has long been considered a
                    safe-haven asset, particularly during times of economic
                    uncertainty and geopolitical instability. In an increasingly
                    volatile global landscape, investors turn to gold as a store
                    of value and a hedge against inflation, currency
                    fluctuations, and market downturns. The uncertainty
                    surrounding major events such as Brexit, trade tensions, and
                    the COVID-19 pandemic has fueled demand for gold, driving
                    prices higher.
                </p>

                <p>
                    2.Low Interest Rates: In a low-interest-rate environment,
                    where traditional fixed-income investments offer minimal
                    returns, gold becomes more attractive as an alternative
                    asset class. With central banks around the world
                    implementing accommodative monetary policies and keeping
                    interest rates near historic lows, the opportunity cost of
                    holding gold diminishes, leading investors to allocate more
                    capital towards the precious metal.
                </p>

                <p>
                    3. Dollar Weakness: The inverse relationship between the US
                    dollar and gold prices is well-documented. A weaker US
                    dollar typically boosts demand for gold as it becomes
                    cheaper for international buyers. The depreciation of the
                    dollar against other major currencies, coupled with concerns
                    over its long-term stability, has bolstered gold prices and
                    contributed to its upward trajectory.
                </p>

                <p>
                    4.Supply Constraints: While the demand for gold continues to
                    rise, the supply side faces challenges such as declining
                    mine production and geopolitical tensions in key
                    gold-producing regions. These supply constraints put upward
                    pressure on gold prices, further driving its appreciation
                    over time.
                </p>

                <p>
                    5. Investor Sentiment: Beyond its fundamental value, gold
                    also benefits from investor sentiment and market psychology.
                    As fear and uncertainty grip financial markets, investors
                    flock to gold for its perceived safety and stability,
                    creating a self-reinforcing cycle of demand that propels
                    prices higher.
                </p>
                <p>
                    As Ethigold strives to democratize gold ownership and make
                    it accessible to all individuals, the recent surge in gold
                    prices underscores the importance of including gold in a
                    diversified investment portfolio. With its mission to
                    revolutionize gold investment in India, Ethigold empowers
                    investors to participate in the potential wealth
                    preservation and growth offered by gold, ensuring financial
                    empowerment and security for a brighter tomorrow.
                </p>
            </>
        ),
        date: "June 17, 2024",
        tags: ["gold", "gold price", "gold rise"],
    },
    {
        id: "11th",
        image: "/etho/11.jpg",
        heading: "NUQI 2024 Ethosphere : 11th Edition",
        description: `Simmering Currencies could reach boiling Point`,
        path: "https://nuqiwealth.com/pdf/NUQI-2024-Ethosphere-11th-Edition.pdf",
        content: (
            <>
                <p>
                    In recent years, the price of gold has experienced a
                    significant surge, reflecting its status as a valuable and
                    sought-after asset. Let’s delve into the factors behind this
                    remarkable rise and explore why gold continues to capture
                    the attention of investors worldwide.
                </p>

                <p>
                    1. Market Uncertainty: Gold has long been considered a
                    safe-haven asset, particularly during times of economic
                    uncertainty and geopolitical instability. In an increasingly
                    volatile global landscape, investors turn to gold as a store
                    of value and a hedge against inflation, currency
                    fluctuations, and market downturns. The uncertainty
                    surrounding major events such as Brexit, trade tensions, and
                    the COVID-19 pandemic has fueled demand for gold, driving
                    prices higher.
                </p>

                <p>
                    2.Low Interest Rates: In a low-interest-rate environment,
                    where traditional fixed-income investments offer minimal
                    returns, gold becomes more attractive as an alternative
                    asset class. With central banks around the world
                    implementing accommodative monetary policies and keeping
                    interest rates near historic lows, the opportunity cost of
                    holding gold diminishes, leading investors to allocate more
                    capital towards the precious metal.
                </p>

                <p>
                    3. Dollar Weakness: The inverse relationship between the US
                    dollar and gold prices is well-documented. A weaker US
                    dollar typically boosts demand for gold as it becomes
                    cheaper for international buyers. The depreciation of the
                    dollar against other major currencies, coupled with concerns
                    over its long-term stability, has bolstered gold prices and
                    contributed to its upward trajectory.
                </p>

                <p>
                    4.Supply Constraints: While the demand for gold continues to
                    rise, the supply side faces challenges such as declining
                    mine production and geopolitical tensions in key
                    gold-producing regions. These supply constraints put upward
                    pressure on gold prices, further driving its appreciation
                    over time.
                </p>

                <p>
                    5. Investor Sentiment: Beyond its fundamental value, gold
                    also benefits from investor sentiment and market psychology.
                    As fear and uncertainty grip financial markets, investors
                    flock to gold for its perceived safety and stability,
                    creating a self-reinforcing cycle of demand that propels
                    prices higher.
                </p>
                <p>
                    As Ethigold strives to democratize gold ownership and make
                    it accessible to all individuals, the recent surge in gold
                    prices underscores the importance of including gold in a
                    diversified investment portfolio. With its mission to
                    revolutionize gold investment in India, Ethigold empowers
                    investors to participate in the potential wealth
                    preservation and growth offered by gold, ensuring financial
                    empowerment and security for a brighter tomorrow.
                </p>
            </>
        ),
        date: "July 1, 2024",
        tags: ["gold", "gold price", "gold rise"],
    },
    {
        id: "12th",
        image: "/etho/12.jpg",
        heading: "NUQI 2024 Ethosphere : 12th Edition",
        description: `The Magnificent eighth is in Great Demand`,
        path: "https://nuqiwealth.com/pdf/NUQI-2024-Ethosphere-12th-Edition.pdf",
        content: (
            <>
                <p>
                    In recent years, the price of gold has experienced a
                    significant surge, reflecting its status as a valuable and
                    sought-after asset. Let’s delve into the factors behind this
                    remarkable rise and explore why gold continues to capture
                    the attention of investors worldwide.
                </p>

                <p>
                    1. Market Uncertainty: Gold has long been considered a
                    safe-haven asset, particularly during times of economic
                    uncertainty and geopolitical instability. In an increasingly
                    volatile global landscape, investors turn to gold as a store
                    of value and a hedge against inflation, currency
                    fluctuations, and market downturns. The uncertainty
                    surrounding major events such as Brexit, trade tensions, and
                    the COVID-19 pandemic has fueled demand for gold, driving
                    prices higher.
                </p>

                <p>
                    2.Low Interest Rates: In a low-interest-rate environment,
                    where traditional fixed-income investments offer minimal
                    returns, gold becomes more attractive as an alternative
                    asset class. With central banks around the world
                    implementing accommodative monetary policies and keeping
                    interest rates near historic lows, the opportunity cost of
                    holding gold diminishes, leading investors to allocate more
                    capital towards the precious metal.
                </p>

                <p>
                    3. Dollar Weakness: The inverse relationship between the US
                    dollar and gold prices is well-documented. A weaker US
                    dollar typically boosts demand for gold as it becomes
                    cheaper for international buyers. The depreciation of the
                    dollar against other major currencies, coupled with concerns
                    over its long-term stability, has bolstered gold prices and
                    contributed to its upward trajectory.
                </p>

                <p>
                    4.Supply Constraints: While the demand for gold continues to
                    rise, the supply side faces challenges such as declining
                    mine production and geopolitical tensions in key
                    gold-producing regions. These supply constraints put upward
                    pressure on gold prices, further driving its appreciation
                    over time.
                </p>

                <p>
                    5. Investor Sentiment: Beyond its fundamental value, gold
                    also benefits from investor sentiment and market psychology.
                    As fear and uncertainty grip financial markets, investors
                    flock to gold for its perceived safety and stability,
                    creating a self-reinforcing cycle of demand that propels
                    prices higher.
                </p>
                <p>
                    As Ethigold strives to democratize gold ownership and make
                    it accessible to all individuals, the recent surge in gold
                    prices underscores the importance of including gold in a
                    diversified investment portfolio. With its mission to
                    revolutionize gold investment in India, Ethigold empowers
                    investors to participate in the potential wealth
                    preservation and growth offered by gold, ensuring financial
                    empowerment and security for a brighter tomorrow.
                </p>
            </>
        ),
        date: "July 8, 2024",
        tags: ["gold", "gold price", "gold rise"],
    },
    {
        id: "13th",
        image: "/etho/13.jpg",
        heading: "NUQI 2024 Ethosphere : 13th Edition",
        description: `Is it time to consider European Equities again?`,
        path: "https://nuqiwealth.com/pdf/NUQI-2024-Ethosphere-13th-Edition.pdf",
        content: (
            <>
                <p>
                    In recent years, the price of gold has experienced a
                    significant surge, reflecting its status as a valuable and
                    sought-after asset. Let’s delve into the factors behind this
                    remarkable rise and explore why gold continues to capture
                    the attention of investors worldwide.
                </p>

                <p>
                    1. Market Uncertainty: Gold has long been considered a
                    safe-haven asset, particularly during times of economic
                    uncertainty and geopolitical instability. In an increasingly
                    volatile global landscape, investors turn to gold as a store
                    of value and a hedge against inflation, currency
                    fluctuations, and market downturns. The uncertainty
                    surrounding major events such as Brexit, trade tensions, and
                    the COVID-19 pandemic has fueled demand for gold, driving
                    prices higher.
                </p>

                <p>
                    2.Low Interest Rates: In a low-interest-rate environment,
                    where traditional fixed-income investments offer minimal
                    returns, gold becomes more attractive as an alternative
                    asset class. With central banks around the world
                    implementing accommodative monetary policies and keeping
                    interest rates near historic lows, the opportunity cost of
                    holding gold diminishes, leading investors to allocate more
                    capital towards the precious metal.
                </p>

                <p>
                    3. Dollar Weakness: The inverse relationship between the US
                    dollar and gold prices is well-documented. A weaker US
                    dollar typically boosts demand for gold as it becomes
                    cheaper for international buyers. The depreciation of the
                    dollar against other major currencies, coupled with concerns
                    over its long-term stability, has bolstered gold prices and
                    contributed to its upward trajectory.
                </p>

                <p>
                    4.Supply Constraints: While the demand for gold continues to
                    rise, the supply side faces challenges such as declining
                    mine production and geopolitical tensions in key
                    gold-producing regions. These supply constraints put upward
                    pressure on gold prices, further driving its appreciation
                    over time.
                </p>

                <p>
                    5. Investor Sentiment: Beyond its fundamental value, gold
                    also benefits from investor sentiment and market psychology.
                    As fear and uncertainty grip financial markets, investors
                    flock to gold for its perceived safety and stability,
                    creating a self-reinforcing cycle of demand that propels
                    prices higher.
                </p>
                <p>
                    As Ethigold strives to democratize gold ownership and make
                    it accessible to all individuals, the recent surge in gold
                    prices underscores the importance of including gold in a
                    diversified investment portfolio. With its mission to
                    revolutionize gold investment in India, Ethigold empowers
                    investors to participate in the potential wealth
                    preservation and growth offered by gold, ensuring financial
                    empowerment and security for a brighter tomorrow.
                </p>
            </>
        ),
        date: "July 15, 2024",
        tags: ["gold", "gold price", "gold rise"],
    },
    {
        id: "14th",
        image: "/etho/14.jpg",
        heading: "NUQI 2024 Ethosphere : 14th Edition",
        description: `Rate Cuts: Which assets will Benefit most?`,
        path: "https://nuqiwealth.com/pdf/NUQI-2024-Ethosphere-14th-Edition.pdf",
        content: (
            <>
                <p>
                    In recent years, the price of gold has experienced a
                    significant surge, reflecting its status as a valuable and
                    sought-after asset. Let’s delve into the factors behind this
                    remarkable rise and explore why gold continues to capture
                    the attention of investors worldwide.
                </p>

                <p>
                    1. Market Uncertainty: Gold has long been considered a
                    safe-haven asset, particularly during times of economic
                    uncertainty and geopolitical instability. In an increasingly
                    volatile global landscape, investors turn to gold as a store
                    of value and a hedge against inflation, currency
                    fluctuations, and market downturns. The uncertainty
                    surrounding major events such as Brexit, trade tensions, and
                    the COVID-19 pandemic has fueled demand for gold, driving
                    prices higher.
                </p>

                <p>
                    2.Low Interest Rates: In a low-interest-rate environment,
                    where traditional fixed-income investments offer minimal
                    returns, gold becomes more attractive as an alternative
                    asset class. With central banks around the world
                    implementing accommodative monetary policies and keeping
                    interest rates near historic lows, the opportunity cost of
                    holding gold diminishes, leading investors to allocate more
                    capital towards the precious metal.
                </p>

                <p>
                    3. Dollar Weakness: The inverse relationship between the US
                    dollar and gold prices is well-documented. A weaker US
                    dollar typically boosts demand for gold as it becomes
                    cheaper for international buyers. The depreciation of the
                    dollar against other major currencies, coupled with concerns
                    over its long-term stability, has bolstered gold prices and
                    contributed to its upward trajectory.
                </p>

                <p>
                    4.Supply Constraints: While the demand for gold continues to
                    rise, the supply side faces challenges such as declining
                    mine production and geopolitical tensions in key
                    gold-producing regions. These supply constraints put upward
                    pressure on gold prices, further driving its appreciation
                    over time.
                </p>

                <p>
                    5. Investor Sentiment: Beyond its fundamental value, gold
                    also benefits from investor sentiment and market psychology.
                    As fear and uncertainty grip financial markets, investors
                    flock to gold for its perceived safety and stability,
                    creating a self-reinforcing cycle of demand that propels
                    prices higher.
                </p>
                <p>
                    As Ethigold strives to democratize gold ownership and make
                    it accessible to all individuals, the recent surge in gold
                    prices underscores the importance of including gold in a
                    diversified investment portfolio. With its mission to
                    revolutionize gold investment in India, Ethigold empowers
                    investors to participate in the potential wealth
                    preservation and growth offered by gold, ensuring financial
                    empowerment and security for a brighter tomorrow.
                </p>
            </>
        ),
        date: "July 22, 2024",
        tags: ["gold", "gold price", "gold rise"],
    },

    {
        id: "15th",
        image: "/etho/15.jpg",
        heading: "NUQI 2024 Ethosphere : 15th Edition",
        description: `The Trump trade has not said it's last Word`,
        path: "https://nuqiwealth.com/pdf/NUQI-2024-Ethosphere-15th-Edition.pdf",
        content: (
            <>
                <p>
                    In recent years, the price of gold has experienced a
                    significant surge, reflecting its status as a valuable and
                    sought-after asset. Let’s delve into the factors behind this
                    remarkable rise and explore why gold continues to capture
                    the attention of investors worldwide.
                </p>

                <p>
                    1. Market Uncertainty: Gold has long been considered a
                    safe-haven asset, particularly during times of economic
                    uncertainty and geopolitical instability. In an increasingly
                    volatile global landscape, investors turn to gold as a store
                    of value and a hedge against inflation, currency
                    fluctuations, and market downturns. The uncertainty
                    surrounding major events such as Brexit, trade tensions, and
                    the COVID-19 pandemic has fueled demand for gold, driving
                    prices higher.
                </p>

                <p>
                    2.Low Interest Rates: In a low-interest-rate environment,
                    where traditional fixed-income investments offer minimal
                    returns, gold becomes more attractive as an alternative
                    asset class. With central banks around the world
                    implementing accommodative monetary policies and keeping
                    interest rates near historic lows, the opportunity cost of
                    holding gold diminishes, leading investors to allocate more
                    capital towards the precious metal.
                </p>

                <p>
                    3. Dollar Weakness: The inverse relationship between the US
                    dollar and gold prices is well-documented. A weaker US
                    dollar typically boosts demand for gold as it becomes
                    cheaper for international buyers. The depreciation of the
                    dollar against other major currencies, coupled with concerns
                    over its long-term stability, has bolstered gold prices and
                    contributed to its upward trajectory.
                </p>

                <p>
                    4.Supply Constraints: While the demand for gold continues to
                    rise, the supply side faces challenges such as declining
                    mine production and geopolitical tensions in key
                    gold-producing regions. These supply constraints put upward
                    pressure on gold prices, further driving its appreciation
                    over time.
                </p>

                <p>
                    5. Investor Sentiment: Beyond its fundamental value, gold
                    also benefits from investor sentiment and market psychology.
                    As fear and uncertainty grip financial markets, investors
                    flock to gold for its perceived safety and stability,
                    creating a self-reinforcing cycle of demand that propels
                    prices higher.
                </p>
                <p>
                    As Ethigold strives to democratize gold ownership and make
                    it accessible to all individuals, the recent surge in gold
                    prices underscores the importance of including gold in a
                    diversified investment portfolio. With its mission to
                    revolutionize gold investment in India, Ethigold empowers
                    investors to participate in the potential wealth
                    preservation and growth offered by gold, ensuring financial
                    empowerment and security for a brighter tomorrow.
                </p>
            </>
        ),
        date: "July 29, 2024",
        tags: ["gold", "gold price", "gold rise"],
    },

    {
        id: "16th",
        image: "/etho/DALL·E 2025-01-03 20.57.37 - An elegant finance-themed visual representing luxury investments in the second-hand market, featuring high-end stock market symbols, gold bars, and lu.jpg",
        heading: "NUQI 2024 Ethosphere : 16th Edition",
        description: `Luxury looks at it second hand image in the second hand market`,
        path: "https://nuqiwealth.com/pdf/NUQI-2024-Ethosphere-16th-Edition.pdf",
        date: "August 21st, 2024",
        tags: ["gold", "gold price", "gold rise"],


    },

    {
        id: "17th",
        image: "/etho/11.jpg",
        heading: "NUQI 2024 Ethosphere : 31st Edition",
        description: `Will there be quality jobs in 2026`,
        path: "https://nuqiwealth.com/pdf/NUQI-2024-Ethosphere-31sth-Edition.pdf",
        content: (
            <>
                <p>
                    In recent years, the price of gold has experienced a
                    significant surge, reflecting its status as a valuable and
                    sought-after asset. Let’s delve into the factors behind this
                    remarkable rise and explore why gold continues to capture
                    the attention of investors worldwide.
                </p>

                <p>
                    1. Market Uncertainty: Gold has long been considered a
                    safe-haven asset, particularly during times of economic
                    uncertainty and geopolitical instability. In an increasingly
                    volatile global landscape, investors turn to gold as a store
                    of value and a hedge against inflation, currency
                    fluctuations, and market downturns. The uncertainty
                    surrounding major events such as Brexit, trade tensions, and
                    the COVID-19 pandemic has fueled demand for gold, driving
                    prices higher.
                </p>

                <p>
                    2.Low Interest Rates: In a low-interest-rate environment,
                    where traditional fixed-income investments offer minimal
                    returns, gold becomes more attractive as an alternative
                    asset class. With central banks around the world
                    implementing accommodative monetary policies and keeping
                    interest rates near historic lows, the opportunity cost of
                    holding gold diminishes, leading investors to allocate more
                    capital towards the precious metal.
                </p>

                <p>
                    3. Dollar Weakness: The inverse relationship between the US
                    dollar and gold prices is well-documented. A weaker US
                    dollar typically boosts demand for gold as it becomes
                    cheaper for international buyers. The depreciation of the
                    dollar against other major currencies, coupled with concerns
                    over its long-term stability, has bolstered gold prices and
                    contributed to its upward trajectory.
                </p>

                <p>
                    4.Supply Constraints: While the demand for gold continues to
                    rise, the supply side faces challenges such as declining
                    mine production and geopolitical tensions in key
                    gold-producing regions. These supply constraints put upward
                    pressure on gold prices, further driving its appreciation
                    over time.
                </p>

                <p>
                    5. Investor Sentiment: Beyond its fundamental value, gold
                    also benefits from investor sentiment and market psychology.
                    As fear and uncertainty grip financial markets, investors
                    flock to gold for its perceived safety and stability,
                    creating a self-reinforcing cycle of demand that propels
                    prices higher.
                </p>
                <p>
                    As Ethigold strives to democratize gold ownership and make
                    it accessible to all individuals, the recent surge in gold
                    prices underscores the importance of including gold in a
                    diversified investment portfolio. With its mission to
                    revolutionize gold investment in India, Ethigold empowers
                    investors to participate in the potential wealth
                    preservation and growth offered by gold, ensuring financial
                    empowerment and security for a brighter tomorrow.
                </p>
            </>
        ),
        date: "December 16, 2024",
        tags: ["gold", "gold price", "gold rise"],
    },
    {
        id: "18th",
        image: "/etho/DALL·E 2025-01-03 21.01.45 - A finance-themed visual illustrating the instability of small-cap stocks. The scene features a cracked, uneven floor under a stock chart, symbolizing .jpg",
        heading: "NUQI 2024 Ethosphere : 18th Edition",
        description: `Small Caps: The Floor is not solid enough`,
        path: "https://nuqiwealth.com/pdf/NUQI-2024-Ethosphere-18th-Edition.pdf",
        date: "September 2nd, 2024",
        tags: ["gold", "gold price", "gold rise"],
    },
    {
        id: "19th",
        image: "/etho/DALL·E 2025-01-03 21.04.34 - An informative and visually engaging image representing how to assess the risk of a recession. The scene features a balance scale with key economic in.jpg",
        heading: "NUQI 2024 Ethosphere : 19th Edition",
        description: `How do you access the risk of recession`,
        path: "https://nuqiwealth.com/pdf/NUQI-2024-Ethosphere-19th-Edition.pdf",
        date: "September 16th, 2024",
        tags: ["gold", "gold price", "gold rise"],


    },
    {
        id: "20th",
        image: "/etho/DALL·E 2025-01-03 21.06.36 - A visually engaging image symbolizing confidence in the semiconductor industry. The scene features a futuristic circuit board with glowing pathways, s.jpg",
        heading: "NUQI 2024 Ethosphere : 20th Edition",
        description: `Semo Confidence in Semi Conductors`,
        path: "https://nuqiwealth.com/pdf/NUQI-2024-Ethosphere-20th-Edition.pdf",
        date: "September 30th, 2024",
        tags: ["gold", "gold price", "gold rise"],
    },
    {
        id: "21st",
        image: "/etho/DALL·E 2025-01-03 21.07.45 - A visually compelling image symbolizing bonds on the road to success. The scene features a winding road made of financial charts and bond certificates.jpg",
        heading: "NUQI 2024 Ethosphere : 21st Edition",
        description: `Bonds are on the road to success`,
        path: "https://nuqiwealth.com/pdf/NUQI-2024-Ethosphere-21st-Edition.pdf",
        date: "September 30th, 2024",
        tags: ["gold", "gold price", "gold rise"],
    },
    {
        id: "22nd",
        image: "/etho/10.jpg",
        heading: "NUQI 2024 Ethosphere : 22nd Edition",
        description: `France's Risk premium has not yet peeked`,
        path: "https://nuqiwealth.com/pdf/NUQI-2024-Ethosphere-22nd-Edition.pdf",
        date: "October 07th, 2024",
        tags: ["gold", "gold price", "gold rise"],


    },
    {
        id: "23rd",
        image: "/etho/DALL·E 2025-01-03 21.09.40 - A finance-themed image representing stable and predictable stocks. The scene features a strong and steady financial graph with minimal fluctuations, s.jpg",
        heading: "NUQI 2024 Ethosphere : 23rd Edition",
        description: `Looking for Stable and predictable stocks`,
        path: "https://nuqiwealth.com/pdf/NUQI-2024-Ethosphere-24th-Edition.pdf",
        date: "October 14th, 2024",
        tags: ["gold", "gold price", "gold rise"],


    },
    {
        id: "24th",
        image: "/etho/DALL·E 2025-01-03 21.10.54 - A thought-provoking image exploring the credibility of China's economic rebound. The scene features a bustling modern cityscape with towering skyscrap.jpg",
        heading: "NUQI 2024 Ethosphere : 24th Edition",
        description: `Is China's spectacular rebound Credible?`,
        path: "https://nuqiwealth.com/pdf/NUQI-2024-Ethosphere-24th-Edition.pdf",
        date: "October 21st, 2024",
        tags: ["gold", "gold price", "gold rise"],


    },
    {
        id: "25th",
        image: "/etho/DALL·E 2025-01-03 21.12.25 - A striking image symbolizing the value and prestige of gold. The scene features a gleaming gold medal placed atop a pile of gold bars, with a radiant .jpg",
        heading: "NUQI 2024 Ethosphere : 25th Edition",
        description: `The Gold medal lives up to its name `,
        path: "https://nuqiwealth.com/pdf/NUQI-2024-Ethosphere-25th-Edition.pdf",
        date: "October 30th, 2024",
        tags: ["gold", "gold price", "gold rise"],


    },
    {
        id: "26th",
        image: "/etho/15.jpg",
        heading: "NUQI 2024 Ethosphere : 26th Edition",
        description: `Impact of US elections `,
        path: "https://nuqiwealth.com/pdf/NUQI-2024-Ethosphere-26th-Edition.pdf",
        date: "November 11, 2024",
        tags: ["gold", "gold price", "gold rise"],
    },
    {
        id: "27th",
        image: "/etho/DALL·E 2025-01-03 21.14.21 - A visually dynamic and thought-provoking image contrasting happiness and euphoria. The scene features two side-by-side paths_ one with a serene, calm .jpg",
        heading: "NUQI 2024 Ethosphere : 27th Edition",
        description: `Happiness is not good enough? Demand Euphoria `,
        path: "https://nuqiwealth.com/pdf/NUQI-2024-Ethosphere-28th-Edition.pdf",
        date: "November 18, 2024",
        tags: ["gold", "gold price", "gold rise"],
    },

    {
        id: "28th",
        image: "/etho/15.jpg",
        heading: "NUQI 2024 Ethosphere : 28th Edition",
        description: `2025 Outlook: Can Donald trump reduce the US trade deficit `,
        path: "https://nuqiwealth.com/pdf/NUQI-2024-Ethosphere-28th-Edition.pdf",
        date: "November 25, 2024",
        tags: ["gold", "gold price", "gold rise"],
    },
    {
        id: "29th",
        image: "/etho/DALL·E 2025-01-03 21.15.41 - A conceptual and dramatic image representing the 2025 economic outlook, focusing on uncertainty and safety. The scene features a turbulent sky with st.jpg",
        heading: "NUQI 2024 Ethosphere : 29th Edition",
        description: `2025 Outlook: Where are the parachutes `,
        path: "https://nuqiwealth.com/pdf/NUQI-2024-Ethosphere-29th-Edition.pdf",
        date: "December 02, 2024",
        tags: ["gold", "gold price", "gold rise"],


    },

    {
        id: "30th",
        image: "/etho/30.jpeg",
        heading: "NUQI 2024 Ethosphere : 30th Edition",
        description: `CRISIS IN FRANCE... WHAT IF IT RHYMED WITH CHANCE AND PATIENCE? `,
        path: "https://nuqiwealth.com/pdf/NUQI-2024-Ethosphere-30th-Edition.pdf",
        date: "December 09, 2024",
        tags: ["gold", "gold price", "gold rise"],
    },

    {
        id: "31st",
        image: "/etho/31.jpeg",
        heading: "NUQI 2024 Ethosphere : 31st Edition",
        description: `WILL THERE BE QUALITY JOBS IN 2025?`,
        path: "https://nuqiwealth.com/pdf/NUQI-2024-Ethosphere-31sth-Edition.pdf",
        date: "December 16, 2024",
        tags: ["gold", "gold price", "gold rise"],
    },

    {
        id: "32nd",
        image: "/etho/32.jpeg",
        heading: "NUQI 2024 Ethosphere : 32nd Edition",
        description: `VIETNAM GOES BEYOND ITS FRONTIERS TO BECOME A KEY PLAYER`,
        path: "https://nuqiwealth.com/pdf/NUQI-2024-Ethosphere-32nd-Edition.pdf",
        date: "December 16, 2024",
        tags: ["gold", "gold price", "gold rise"],
    },

    {
        id: "33rd",
        image: "/etho/33.jpeg",
        heading: "NUQI 2025 Ethosphere : 33rd Edition",
        description: `IN EUROPE, IT'S BETTER TO AIM OUTSIDE THE ZONE`,
        path: "https://nuqiwealth.com/pdf/Ethosphere%2033rd%20edition%20(13th%20Jan%202025).pdf",
        date: "January 13, 2025",
        tags: ["gold", "gold price", "gold rise"],
    },
    {
        id: "34th",
        image: "/etho/34.jpeg",
        heading: "NUQI 2025 Ethosphere : 34th Edition",
        description: `RATES ARE SOARING, SHOULD WE WORRY OR SEIZE THE OPPORTUNITY?`,

        path: "https://nuqiwealth.com/pdf/NUQI-2024-Ethosphere-34th-Edition.pdf",
        date: "January 20, 2025",
        tags: ["gold", "gold price", "gold rise"],
    },

    {
        id: "35th",
        image: "/etho/35.jpeg",
        heading: "NUQI 2025 Ethosphere : 35th Edition",
        description: `SMALL OR LARGE CAPS? IT'S TIME TO COMPROMISE`,

        path: "https://nuqiwealth.com/pdf/NUQI-2024-Ethosphere-35th-Edition.pdf",
        date: "January 27, 2025",
        tags: ["gold", "gold price", "gold rise"],
    },
    {
        id: "36th",
        image: "/etho/36.jpg",
        heading: "NUQI 2025 Ethosphere : 36th Edition",
        description: `Dispersion is not Necessarily Something Bad`,

        path: "https://nuqiwealth.com/pdf/NUQI-2024-Ethosphere-36th-Edition.pdf",
        date: "February 03, 2025",
        tags: ["gold", "gold price", "gold rise"],
    },
    {
        id: "37th",
        image: "/etho/37.png",
        heading: "NUQI 2025 Ethosphere : 37th Edition",
        description: `Gold Glitters even in the Mud`,

        path: "https://nuqiwealth.com/pdf/NUQI-2024-Ethosphere-37th-Edition.pdf",
        date: "February 10, 2025",
        tags: ["gold", "gold price", "gold rise"],
    },
    {
        id: "38th",
        image: "/etho/38.png",
        heading: "NUQI 2025 Ethosphere : 38th Edition",
        description: `I know what you did in Summer 1984`,

        path: "https://nuqiwealth.com/pdf/NUQI-2025-Ethosphere-38th-Edition.pdf",
        date: "February 24, 2025",
        tags: ["gold", "gold price", "gold rise"],
    },
    {
        id: "39th",
        image: "/etho/39.png",
        heading: "NUQI 2025 Ethosphere : 39th Edition",
        description: `Yellen the Magician, Bessent the Warlord?`,

        path: "https://nuqiwealth.com/pdf/NUQI-2025-Ethosphere-39th-Edition.pdf",
        date: "March 3, 2025",
        tags: ["gold", "gold price", "gold rise"],
    },
    {
        id: "40th",
        image: "/etho/40.png",
        heading: "NUQI 2025 Ethosphere : 40th Edition",
        description: `To reach the next Peak, Investors will have to cross a Valley`,

        path: "https://nuqiwealth.com/pdf/NUQI-2025-Ethosphere-40th-Edition.pdf",
        date: "March 10, 2025",
        tags: ["gold", "gold price", "gold rise"],
    },
    {
        id: "41st",
        image: "/etho/41.png",
        heading: "NUQI 2025 Ethosphere : 41st Edition",
        description: `Investors enjoy Good Health`,

        path: "https://nuqiwealth.com/pdf/NUQI-2025-Ethosphere-41st-Edition.pdf",
        date: "March 17, 2025",
        tags: ["gold", "gold price", "gold rise"],
    },
    {
        id: "42nd",
        image: "/etho/42.png",
        heading: "NUQI 2025 Ethosphere : 42nd Edition",
        description: `Employment on the Brink`,

        path: "https://nuqiwealth.com/pdf/NUQI-2025-Ethosphere-42nd-Edition.pdf",
        date: "March 24, 2025",
        tags: ["gold", "gold price", "gold rise"],
    },
    {
        id: "43rd",
        image: "/etho/43.png",
        heading: "NUQI 2025 Ethosphere : 43rd Edition",
        description: `Stones are thrown only at Fruit-Bearing Trees`,

        path: "https://nuqiwealth.com/pdf/NUQI-2025-Ethosphere-43rd-Edition.pdf",
        date: "April 02, 2025",
        tags: ["gold", "gold price", "gold rise"],
    },
    {
        id: "44th",
        image: "/etho/44.png",
        heading: "NUQI 2025 Ethosphere : 44th Edition",
        description: `Is Trump a Fusion of the Words Trade & Slump?`,

        path: "https://nuqiwealth.com/pdf/NUQI-2025-Ethosphere-44th-Edition.pdf",
        date: "April 14, 2025",
        tags: ["gold", "gold price", "gold rise"],
    },
    {
        id: "45th",
        image: "/etho/45.png",
        heading: "NUQI 2025 Ethosphere : 45th Edition",
        description: `Tell me how you Spend, I'll tell you who you are`,

        path: "https://nuqiwealth.com/pdf/NUQI-2025-Ethosphere-45th-Edition.pdf",
        date: "May 05, 2025",
        tags: ["gold", "gold price", "gold rise"],
    },
    {
        id: "46th",
        image: "/etho/46.png",
        heading: "NUQI 2025 Ethosphere : 46th Edition",
        description: `Semiconductors attempt a Welcome Rebound`,

        path: "https://nuqiwealth.com/pdf/NUQI-2025-Ethosphere-46th-Edition.pdf",
        date: "May 12, 2025",
        tags: ["gold", "gold price", "gold rise"],
    },
    {
        id: "47th",
        image: "/etho/47.png",
        heading: "NUQI 2025 Ethosphere : 47th Edition",
        description: `Oil : IS it possible to drill Good Retruns?`,

        path: "https://nuqiwealth.com/pdf/NUQI-2025-Ethosphere-47th-Edition.pdf",
        date: "May 19, 2025",
        tags: ["gold", "gold price", "gold rise"],
    },
    {
        id: "48th",
        image: "/etho/48.png",
        heading: "NUQI 2025 Ethosphere : 48th Edition",
        description: `After the 'AAA', It's the 'BBB' that's causing Concern`,

        path: "https://nuqiwealth.com/pdf/NUQI-2025-Ethosphere-48th-Edition.pdf",
        date: "May 26, 2025",
        tags: ["gold", "gold price", "gold rise"],
    },
    {
        id: "49th",
        image: "/etho/49.png",
        heading: "NUQI 2025 Ethosphere : 49th Edition",
        description: "The Real Estate Market is Holding Up, But it needs Props",

        path: "https://nuqiwealth.com/pdf/NUQI-2025-Ethosphere-49th-Edition.pdf",
        date: "June 09, 2025",
        tags: ["gold", "gold price", "gold rise"],
    },
    {
        id: "50th",
        image: "/etho/50.png",
        heading: "NUQI 2025 Ethosphere : 50th Edition",
        description: "Yen Weakness will give Japanese Equities a Major Boost",

        path: "https://nuqiwealth.com/pdf/NUQI-2025-Ethosphere-50th-Edition.pdf",
        date: "June 17, 2025",
        tags: ["gold", "gold price", "gold rise"],
    },
    {
        id: "51th",
        image: "/etho/51.png",
        heading: "NUQI 2025 Ethosphere : 51th Edition",
        description: "European Equities: Dream or Reality?",

        path: "https://nuqiwealth.com/pdf/NUQI-2025-Ethosphere-51th-Edition.pdf",
        date: "June 23, 2025",
        tags: ["gold", "gold price", "gold rise"],
    },
    {
        id: "52th",
        image: "/etho/52.png",
        heading: "NUQI 2025 Ethosphere : 52th Edition",
        description: "Bonds could hold a (very) Pleasant Surprise",

        path: "https://nuqiwealth.com/pdf/NUQI-2025-Ethosphere-52th-Edition.pdf",
        date: "July 01, 2025",
        tags: ["gold", "gold price", "gold rise"],
    },
    {
        id: "53rd",
        image: "/etho/53.png",
        heading: "NUQI 2025 Ethosphere : 53rd Edition",
        description: "The Eclipse of the Dollar King",

        path: "https://nuqiwealth.com/pdf/NUQI-2025-Ethosphere-53rd-Edition.pdf",
        date: "July 07, 2025",
        tags: ["gold", "gold price", "gold rise"],
    },
    {
        id: "54rth",
        image: "/etho/54.png",
        heading: "NUQI 2025 Ethosphere : 54rth Edition",
        description: "Health is becoming Costly!",

        path: "https://nuqiwealth.com/pdf/NUQI-2025-Ethosphere-54rth-Edition.pdf",
        date: "July 22, 2025",
        tags: ["gold", "gold price", "gold rise"],
    },
    {
        id: "55th",
        image: "/etho/55.png",
        heading: "NUQI 2025 Ethosphere : 55th Edition",
        description: "Should France be wearing a Dunce Cap?",

        path: "https://nuqiwealth.com/pdf/NUQI-2025-Ethosphere-55th-Edition.pdf",
        date: "July 29, 2025",
        tags: ["gold", "gold price", "gold rise"],
    },
    {
        id: "56th",
        image: "/etho/56.png",
        heading: "NUQI 2025 Ethosphere : 56th Edition",
        description: "EMPLOYMENT CRISIS: THE ALARM IS SOUNDING",

        path: "https://nuqiwealth.com/pdf/NUQI-2025-Ethosphere-56th-Edition.pdf",
        date: "August 11, 2025",
        tags: ["gold", "gold price", "gold rise"],
    },
    {
        id: "57th",
        image: "/etho/57.png",
        heading: "NUQI 2025 Ethosphere : 57th Edition",
        description: "TOP 50 COMPANIES: DO YOU KNOW THIS YEAR'S HITS?",

        path: "https://nuqiwealth.com/pdf/NUQI-2025-Ethosphere-57th-Edition.pdf",
        date: "August 18, 2025",
        tags: ["gold", "gold price", "gold rise"],
    },
    {
        id: "58th",
        image: "/etho/58.png",
        heading: "NUQI 2025 Ethosphere : 58th Edition",
        description: "THE RETURN OF THE TOP 50: WHAT WILL BE THE NEXT HITS?",

        path: "https://nuqiwealth.com/pdf/NUQI-2025-Ethosphere-58th-Edition.pdf",
        date: "September 1, 2025",
        tags: ["gold", "gold price", "gold rise"],
    },
    {
        id: "59th",
        image: "/etho/59.png",
        heading: "NUQI 2025 Ethosphere : 59th Edition",
        description: "IT'S THE ECONOMY, STUPID!",

        path: "https://nuqiwealth.com/pdf/NUQI-2025-Ethosphere-59th-Edition.pdf",
        date: "September 8, 2025",
        tags: ["gold", "gold price", "gold rise"],
    },
    {
        id: "60th",
        image: "/etho/60.png",
        heading: "NUQI 2025 Ethosphere : 60th Edition",
        description: "WILL THE NEXT CRISIS BE IN THE REAL ESTATE MARKET?",

        path: "https://nuqiwealth.com/pdf/NUQI-2025-Ethosphere-60th-Edition.pdf",
        date: "September 30, 2025",
        tags: ["gold", "gold price", "gold rise"],
    },
    {
        id: "61st",
        image: "/etho/61.png",
        heading: "NUQI 2025 Ethosphere : 61st Edition",
        description: "CHINA MOVES TOWARDS DEVELOPED COUNTRY STATUS",

        path: "https://nuqiwealth.com/pdf/NUQI-2025-Ethosphere-61st-Edition.pdf",
        date: "October 06, 2025",
        tags: ["gold", "gold price", "gold rise"],
    },
    {
        id: "62nd",
        image: "/etho/62.png",
        heading: "NUQI 2025 Ethosphere : 62nd Edition",
        description: "WHAT IF INVESTORS FAVOUR A MEDIEVAL APPROACH?",
        path: "https://nuqiwealth.com/pdf/NUQI-2025-Ethosphere-62nd-Edition.pdf",
        date: "October 13, 2025",
        tags: ["gold", "gold price", "gold rise"],
    },
    {
        id: "63rd",
        image: "/etho/63.png",
        heading: "NUQI 2025 Ethosphere : 63rd Edition",
        description: "UNITED STATES, CHINA & EURO AREA: THREE GIANTS NOT SO DIFFERENT",
        path: "https://nuqiwealth.com/pdf/NUQI-2025-Ethosphere-63rd-Edition.pdf",
        date: "October 20, 2025",
        tags: ["gold", "gold price", "gold rise"],
    },
    {
        id: "64th",
        image: "/etho/64.png",
        heading: "NUQI 2025 Ethosphere : 64th Edition",
        description: "RISK-FREE ASSET SET TO MAKE A COMEBACK",
        path: "https://nuqiwealth.com/pdf/NUQI-2025-Ethosphere-64th-Edition.pdf",
        date: "October 27, 2025",
        tags: ["gold", "gold price", "gold rise"],
    },
    {
        id: "65th",
        image: "/etho/65.png",
        heading: "NUQI 2025 Ethosphere : 65th Edition",
        description: "WHAT IF THE SNB WENT DOWN TO A LOWER FLOOR?",
        path: "https://nuqiwealth.com/pdf/NUQI-2025-Ethosphere-65th-Edition.pdf",
        date: "November 03, 2025",
        tags: ["gold", "gold price", "gold rise"],
    },
    {
        id: "66th",
        image: "/etho/66.png",
        heading: "NUQI 2025 Ethosphere : 66th Edition",
        description: "SPOTLIGHT ON THE LEAST VISIBLE SECTOR",
        path: "https://nuqiwealth.com/pdf/NUQI-2025-Ethosphere-66th-Edition.pdf",
        date: "November 17, 2025",
        tags: ["gold", "gold price", "gold rise"],
    },
    {
        id: "67th",
        image: "/etho/67.png",
        heading: "NUQI 2025 Ethosphere : 67th Edition",
        description: "THE FIGHT AGAINST OBESITY, A REVOLUTION UNDER PRESSURE",
        path: "https://nuqiwealth.com/pdf/NUQI-2025-Ethosphere-67th-Edition.pdf",
        date: "December 01, 2025",
        tags: ["gold", "gold price", "gold rise"],
    },
    {
        id: "68th",
        image: "/etho/68.png",
        heading: "NUQI 2025 Ethosphere : 68th Edition",
        description: "THE FUTURE OF BLACK GOLD LOOKS ROSY",
        path: "https://nuqiwealth.com/pdf/NUQI-2025-Ethosphere-68th-Edition.pdf",
        date: "December 08, 2025",
        tags: ["gold", "gold price", "gold rise"],
    },
    {
        id: "69th",
        image: "/etho/69.png",
        heading: "NUQI 2025 Ethosphere : 69th Edition",
        description: "WILL JAPAN BE AT THE HEART OF THE NEXT CRISIS?",
        path: "https://nuqiwealth.com/pdf/NUQI-2025-Ethosphere-69th-Edition.pdf",
        date: "December 15, 2025",
        tags: ["gold", "gold price", "gold rise"],
    },
    {
        id: "70th",
        image: "/etho/70.png",
        heading: "NUQI 2025 Ethosphere : 70th Edition",
        description: "2026 OUTLOOK: THE WIND IS RISING, BUT THE CREW IS READY",
        path: "https://nuqiwealth.com/pdf/NUQI-2025-Ethosphere-70th-Edition.pdf",
        date: "January 05, 2026",
        tags: ["gold", "gold price", "gold rise"],
    },
    {
        id: "71st",
        image: "/etho/71.png",
        heading: "NUQI 2025 Ethosphere : 71st Edition",
        description: "THE COPPER CRUNCH AND THE WALL OF MEMORY",
        path: "https://nuqiwealth.com/pdf/NUQI-2025-Ethosphere-71st-Edition.pdf",
        date: "January 12, 2026",
        tags: ["gold", "gold price", "gold rise"],
    },
    {
        id: "72nd",
        image: "/etho/72.png",
        heading: "NUQI 2025 Ethosphere : 72nd Edition",
        description: "THE CURRENCY WALTZ HAS NOT YET BEGUN",
        path: "https://nuqiwealth.com/pdf/NUQI-2025-Ethosphere-72nd-Edition.pdf",
        date: "January 19, 2026",
        tags: ["gold", "gold price", "gold rise"],
    },
    {
        id: "73rd",
        image: "/etho/73.png",
        heading: "NUQI 2025 Ethosphere : 73rd Edition",
        description: "VIETNAM, AN AMBITION BEYOND BORDERS",
        path: "https://nuqiwealth.com/pdf/NUQI-2025-Ethosphere-73rd-Edition.pdf",
        date: "January 27, 2026",
        tags: ["gold", "gold price", "gold rise"],
    },
    {
        id: "74th",
        image: "/etho/74.png",
        heading: "NUQI 2025 Ethosphere : 74th Edition",
        description: "THE AWAKENING OF BARBAROSSA",
        path: "https://nuqiwealth.com/pdf/NUQI-2025-Ethosphere-74th-Edition.pdf",
        date: "February 02, 2026",
        tags: ["gold", "gold price", "gold rise"],
    },
     {
        id: "75th",
        image: "/etho/75.png",
        heading: "NUQI 2025 Ethosphere : 75th Edition",
        description: "AT THE HEART OF PROGRESS LIES THE ATOM",
        path: "https://nuqiwealth.com/pdf/NUQI-2025-Ethosphere-75th-Edition.pdf",
        date: "February 9, 2026",
        tags: ["gold", "gold price", "gold rise"],
    },
    {
        id: "76th",
        image: "/etho/76.png",
        heading: "NUQI 2025 Ethosphere : 76th Edition",
        description: "HOW MUCH WEIGHT SHOULD BE GIVEN TO EMERGING MARKETS?",
        path: "https://nuqiwealth.com/pdf/NUQI-2025-Ethosphere-76th-Edition.pdf",
        date: "February 16, 2026",
        tags: ["gold", "gold price", "gold rise"],
    },
     {
        id: "77th",
        image: "/etho/77.jpg",
        heading: "NUQI 2025 Ethosphere : 77th Edition",
        description: "NORWAY IS ON THE VERGE OF A BOREAL PERFORMANCE",
        path: "https://nuqiwealth.com/pdf/NUQI-2025-Ethosphere-77th-Edition.pdf",
        date: "February 23, 2026",
        tags: ["gold", "gold price", "gold rise"],
    },
     {
        id: "78th",
        image: "/etho/78.png",
        heading: "NUQI 2025 Ethosphere : 78th Edition",
        description: "WILL BANKS BE AFFECTED BY THE PRIVATE CREDIT CRISIS?",
        path: "https://nuqiwealth.com/pdf/NUQI-2025-Ethosphere-78th-Edition.pdf",
        date: "March 02, 2026",
        tags: ["gold", "gold price", "gold rise"],
    },
     {
        id: "79th",
        image: "/etho/79.png",
        heading: "NUQI 2025 Ethosphere : 79th Edition",
        description: "ARE YOU READY FOR THE FIREWORKS?",
        path: "https://nuqiwealth.com/pdf/NUQI-2025-Ethosphere-79th-Edition.pdf",
        date: "March 16, 2026",
        tags: ["gold", "gold price", "gold rise"],

    },
    {
        id: "80th",
        image: "/etho/80.png",
        heading: "NUQI 2025 Ethosphere : 80th Edition",
        description: "BETWEEN CRISIS AND OPTIMISM, PORTFOLIOS SWING",
        path: "https://nuqiwealth.com/pdf/NUQI-2025-Ethosphere-80th-Edition.pdf",
        date: "March 23, 2026",
        tags: ["gold", "gold price", "gold rise"],
    },
     {
        id: "81st",
        image: "/etho/81.png",
        heading: "NUQI 2025 Ethosphere : 81st Edition",
        description: "WHAT IF THE WAR LASTED A LONG TIME?", 
        path: "https://nuqiwealth.com/pdf/NUQI-2025-Ethosphere-81st-Edition.pdf",
        date: "March 30, 2026",
        tags: ["gold", "gold price", "gold rise"],

    },
     {
        id: "82nd",
        image: "/etho/82.png",
        heading: "NUQI 2025 Ethosphere : 82nd Edition",
        description: "HOW TO AVOID FALLING INTO THE DOLLAR’S BULL TRAP?",
        path: "https://nuqiwealth.com/pdf/NUQI-2025-Ethosphere-82nd-Edition.pdf",
        date: "April 13, 2026",
        tags: ["gold", "gold price", "gold rise"],
    },
    {
        id: "83rd",
        image: "/etho/83.jpg",
        heading: "NUQI 2025 Ethosphere : 83rd Edition",
        description: "THE ADVANTAGE GOES TO THOSE WITH A SLICK TONGUE",
        path: "https://nuqiwealth.com/pdf/NUQI-2025-Ethosphere-83rd-Edition.pdf",
        date: "April 20, 2026",
        tags: ["gold", "gold price", "gold rise"],

    },
    {
        id: "84th",
        image: "/etho/84.png",
        heading: "NUQI 2025 Ethosphere : 84th Edition",
        description: "HAVE LUXURY GOODS BEEN SHELVED?",
        path: "https://nuqiwealth.com/pdf/NUQI-2025-Ethosphere-84th-Edition.pdf",
        date: "April 27, 2026",
        tags: ["gold", "gold price", "gold rise"],
    },
    {
        id: "85th",
        image: "/etho/85.png",
        heading: "NUQI 2025 Ethosphere : 85th Edition",
        description: "CAN VALUATIONS RISE ANY FURTHER?",
        path: "https://nuqiwealth.com/pdf/NUQI-2025-Ethosphere-85th-Edition.pdf",
        date: "May 11, 2026",
        tags: ["gold", "gold price", "gold rise"],
    },
    {
        id: "86th",
        image: "/etho/86.png",
        heading: "NUQI 2025 Ethosphere : 86th Edition",
        description: "THE YIELD CURVE HAS NOT YET PASSED THE BATON",
        path: "https://nuqiwealth.com/pdf/NUQI-2025-Ethosphere-86th-Edition.pdf",
        date: "May 25, 2026",
        tags: ["gold", "gold price", "gold rise"],
    }

];